import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { ViewActionTableCell } from '@components/common';
import AdaptiveTableCell from '@components/common/AdaptiveTableCell';

import {
	IDashboardRequestStatus,
	IDashboardRequestStatusSummary,
} from '@interfaces/platform/platformDashboard';

import { columnSizes } from '@constants/table';

interface IAcquireAssetsColumns {
	openStatusTable: (status: IDashboardRequestStatus) => void;
	isSingleOrganization?: boolean;
}

export const getAcquireAssetsColumns = ({
	openStatusTable,
	isSingleOrganization,
}: IAcquireAssetsColumns) => ([
	{
		header: 'Status',
		accessorKey: 'status',
		cell: ({ row }: CellContext<IDashboardRequestStatusSummary, any>) => {
			const value = row.original?.status.title;

			return <AdaptiveTableCell text={value} />;
		},
	},
	{
		header: 'Requests',
		accessorKey: 'requestCount',
		size: columnSizes.size160,
		cell: ({ getValue }: CellContext<IDashboardRequestStatusSummary, any>) => {
			const value = getValue();

			return (
				<AdaptiveTableCell
					isCentered
					text={value}
				/>
			);
		},
	},
	{
		header: 'AO Organisations',
		accessorKey: 'organizationCount',
		size: columnSizes.size160,
		isHidden: isSingleOrganization,
		cell: ({ getValue, row }: CellContext<IDashboardRequestStatusSummary, any>) => {
			const value = getValue();
			const status = row.original?.status;

			const onClick = () => {
				if (!status) return;

				openStatusTable(status);
			};

			return (
				<ViewActionTableCell
					isCentered
					isDisabled={!value}
					onClick={onClick}
					text={value}
					tooltipLabel='Details'
				/>
			);
		},
	},
]);
